import { createFileRoute } from '@tanstack/react-router';
import { TabLoadError } from '@/features/creators/dashboard/components/load-error';
import {
	LOAD_ERROR_TEXT,
	SOCIAL_TEXT,
} from '@/features/creators/dashboard/content';
import { fetchConnectedPlatforms } from '@/features/creators/dashboard/services/fetch-connected-platforms';
import { SocialPage } from '@/features/creators/dashboard/social/social-page';
import { PageLoader } from '@/features/creators/shared/page-loader';

// /ixi-finance/creators/dashboard/social — the Social tab: the platforms on
// the creator's details and whether each is verified, read-only for now.
export const Route = createFileRoute(
	'/_auth/ixi-finance/creators_/dashboard/social',
)({
	loader: () => fetchConnectedPlatforms(),
	component: SocialRoute,
	pendingComponent: PageLoader,
	errorComponent: () => (
		<TabLoadError page={SOCIAL_TEXT.title} what={LOAD_ERROR_TEXT.platforms} />
	),
});

function SocialRoute() {
	return <SocialPage platforms={Route.useLoaderData()} />;
}
